import { ntbActionType } from '../../actionTypes';
import { lenderListController } from '../../api/controllers/ntbController';

export default (
  payload: Object,
  onSuccessAction?: Function,
  onFailAction?: Function,
) => (dispatch: Function) => {
  const { mobile } = payload;
  const data = {
    mobile: mobile,
  };
  dispatch({
    type: ntbActionType.LENDER_LIST_REQUEST,
    payload: data,
  });
  lenderListController(data)
    .then(({ data: responseData }) => {
      if (onSuccessAction) dispatch(onSuccessAction(responseData, data));
    })
    .catch((error) => {
      if (onFailAction) dispatch(onFailAction(error));
    });
};



// WEBPACK FOOTER //
// ./actions/ntbAction/getLenderList.js